import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useUser } from './hooks/useUser';
import Header from './components/Header';
import NewVersionBanner from './components/NewVersionBanner';
import HomePage from './pages/HomePage';
import ExercisePage from './pages/ExercisePage';
import MiniCoursFirstPage from './pages/MiniCoursFirstPage';
import QuestExercisePage from './pages/QuestExercisePage';
import LoginPage from './pages/LoginPage';
import ProgressionPage from './pages/ProgressionPage';
import AdminPage from './pages/AdminPage';
import RequestPasswordPage from './pages/RequestPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import ProfilePage from './pages/ProfilePage';
import CertificationPage from './pages/CertificationPage';
import CertificationResultsPage from './pages/CertificationResultsPage';
import AITrainingPage from './pages/AITrainingPage';

function App() {
  const { user, isLoading } = useUser();
  const location = useLocation();

  // Check if we're in certification mode (needs full-width)
  const isCertificationRoute = location.pathname.startsWith('/certification') || location.pathname.startsWith('/ai-training');

  // Pages d'exercice : pleine largeur par défaut (conteneur élargi propre, sans hack CSS)
  const isExerciseRoute = (location.pathname.startsWith('/exercise/') && !location.pathname.startsWith('/exercise/quest/')) || location.pathname.startsWith('/mini-cours/');

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div>Chargement de la plateforme...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-950 transition-colors">
      {user && <Header />}
      {/* Use full-width for certification routes, wide container for exercises, normal max-w for others */}
      <main className={
        isCertificationRoute
          ? ''
          : isExerciseRoute
            ? 'w-full px-4 sm:px-6 lg:px-8 py-4'
            : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8'
      }>
        <Routes>
          <Route path="/login" element={!user ? <LoginPage /> : <Navigate to={user.role === 'admin' ? '/admin' : '/'} />} />
          <Route path="/request-password" element={!user ? <RequestPasswordPage /> : <Navigate to="/" />} />
          <Route path="/reset-password" element={!user ? <ResetPasswordPage /> : <Navigate to="/" />} />
          {/* D — inscription par lien d'invitation (la route manquait : lien = page blanche) */}
          <Route path="/accept-invite" element={!user ? <AcceptInvitePage /> : <Navigate to="/" />} />
          <Route path="/exercise/quest/:questId" element={user ? <QuestExercisePage /> : <Navigate to="/login" />} />
          <Route path="/exercise/:exerciseId" element={user ? <ExercisePage /> : <Navigate to="/login" />} />
          <Route path="/exercise/:exerciseId/review/:attemptId" element={user ? <ExercisePage mode="review" /> : <Navigate to="/login" />} />
          {/* B1 — « Mini-cours d'abord » : page de cours avant l'exercice, même garde que /exercise/:exerciseId */}
          <Route path="/mini-cours/:exerciseId" element={user ? <MiniCoursFirstPage /> : <Navigate to="/login" />} />
          <Route path="/progression" element={user ? <ProgressionPage /> : <Navigate to="/login" />} />
          <Route path="/admin" element={user ? <AdminPage /> : <Navigate to="/login" />} />
          <Route path="/profile" element={user ? <ProfilePage /> : <Navigate to="/login" />} />
          <Route path="/certification" element={user ? <CertificationPage /> : <Navigate to="/login" />} />
          <Route path="/certification/results" element={user ? <CertificationResultsPage /> : <Navigate to="/login" />} />
          <Route path="/certification/results/:attemptId" element={user ? <CertificationResultsPage /> : <Navigate to="/login" />} />
          <Route path="/ai-training" element={user ? <AITrainingPage /> : <Navigate to="/login" />} />
          <Route path="/" element={user ? <HomePage /> : <Navigate to="/login" />} />
          {/* D — filet de sécurité : une URL inconnue renvoyait une page blanche */}
          <Route path="*" element={<Navigate to={user ? "/" : "/login"} replace />} />
        </Routes>
      </main>
      <NewVersionBanner />
    </div>
  );
}

export default App; 